import { $color_grey_1, $color_grey_9 } from '../pebbleGlobalToken/color.js';

/**
 * 全局提示-文本颜色。
 * @description enDesc: -
 * @description type: Space
 * @description value: #color_grey_1
 */
var $message_color_text = $color_grey_1;
/**
 * 全局提示-提示框背景色
 * @description enDesc: -
 * @description type: Space
 * @description value: color_grey_9
 */
var $message_color_background = $color_grey_9;
/**
 * 全局提示-提示框内边距
 * @description enDesc: -
 * @description type: Space
 * @description value: '12px 16px'
 */
var $message_padding = '12px';

export { $message_color_background, $message_color_text, $message_padding };
